import { render, staticRenderFns } from "./tag-table.vue?vue&type=template&id=548d2b32"
import script from "./tag-table.vue?vue&type=script&setup=true&lang=js"
export * from "./tag-table.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports